// DOCUMENT
export const MANDATORY_DOCUMENT_TYPE = "Mandatory";
export const ADDITIONAL_DOCUMENT_TYPE = "Additional";
export const ARCHIVED_DOCUMENT_TYPE = "Archived";

export const SUCCESS_DOCUMENT_STATUS = "success";
export const ERROR_DOCUMENT_STATUS = "error";
export const ARCHIVED_DOCUMENT_STATUS = "archived";
export const NOT_PROVIDED_DOCUMENT_STATUS = "not_provided";

export const DOCUMENT_STATUSES = {
  [SUCCESS_DOCUMENT_STATUS]: SUCCESS_DOCUMENT_STATUS,
  [ERROR_DOCUMENT_STATUS]: ERROR_DOCUMENT_STATUS,
  [ARCHIVED_DOCUMENT_STATUS]: ARCHIVED_DOCUMENT_STATUS,
  [NOT_PROVIDED_DOCUMENT_STATUS]: NOT_PROVIDED_DOCUMENT_STATUS,
};

export const APPROVED_DOCUMENT_STATUS = "approved";
export const REJECTED_DOCUMENT_STATUS = "rejected";
export const TO_REVIEW_DOCUMENT_STATUS = "to_review";

export const EXPERT_DOCUMENT_STATUSES = {
  [APPROVED_DOCUMENT_STATUS]: APPROVED_DOCUMENT_STATUS,
  [REJECTED_DOCUMENT_STATUS]: REJECTED_DOCUMENT_STATUS,
  [TO_REVIEW_DOCUMENT_STATUS]: TO_REVIEW_DOCUMENT_STATUS,
};
